<template>
  <div class="mobile_render_banner">
    <div id="Swip" ref="swiper" class="swiper-container">
      <div class="swiper-wrapper">
        <div
          v-for="(item, index) in applicationInfo"
          :key="index"
          class="swiper-slide"
        >
          <img  :src="item.imgUrl" alt="" @click="handleClickStudioVideo(item)"/>
          <div class="lighting_text position_none_lighting_text">
            <p style="font-size: 20px; font-weight: 700; margin-bottom: 10px;">{{ item.title }}</p>
          </div>
          <p class="render_msg">{{ item.msg }}</p>
          <div class="mark">
          </div>
        </div>
      </div>
    </div>
    <youtubeVideo v-if="youtubeVideoId" :youtubeVideoId.sync="youtubeVideoId"/>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
import youtubeVideo from "@/components/en_pc/youtubeVideo.vue";
export default {
  components: {youtubeVideo},
  data() {
    return {
      youtubeVideoId:''
    };
  },
  props: {
    applicationInfo: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    new Swiper(this.$refs.swiper, {
      autoplay: {
        delay: 2000,
        // 交互后保持自动播放
        disableOnInteraction: true,
      },
      pagination: {
        el: ".swiper-pagination",
        // 可点击
        clickable: true,
      },
      // 禁用滑动
      allowTouchMove: true,
    });
  },
  methods:{
    handleClickStudioVideo(item){
      console.log(item);
      if(item.videoId){
        this.youtubeVideoId = item.videoId
      }

    },
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/mobile_wsc.scss";
@media screen and (min-width: 768px){
  .lighting_text p{
    font-size: 26px !important;
  }
  .render_msg{
    font-size: 18px !important;
    height: 140px !important;
  }

}
</style>
